import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import { createSale, getSales, getSaleById, getTotalSalesToday, getTotalSalesThisWeek, getTotalSalesThisMonth, getTotalSalesThisYear, getTotalSalesForDateRange, getSalesData, search, getSalesReport, downloadBill, generateInvoice, updateSale } from "../services/saleService";

const saleModule = createModule({
  name: "sales",
  initialState: {
    isLoading: false,
    error: null,
    currentSale: null,
    cart: [],
    sales: [],
    totalVentes: 0,
    totalVentesDirect: 0,
    totalAchats: 0,
    totalFactureImpayees: 0,
    totalAchatsImpayees: 0,
    purchaseNotPayed: 0,
    purchasePayed: 0,
    invoicePayed: 0,
    invoiceNotPayed: 0,
    invoicePayedPartially: 0,
    totalPurchaseReturns: 0,
    totalSalesReturns: 0,
    totalExpenses: 0,
    totalPOSSales: 0,
    grossRevenue: 0,
    netIncome: 0,
    lowStockItems: [],
    montantTotalTTC: 0,
    montantTotalHT: 0,
    montantTotalTaxe: 0,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 30, // Size of each page
  },
  selectors: {
    getCart: state => state.sales?.cart || [],
    getTotalAmount: state => state.sales?.totalAmount || 0,
    getIsLoading: state => state.sales?.isLoading || false
  },
  reducers: {
    search: (state) => {
      state.isLoading = true;
    },
    createSale: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getSalesData: (state) => {
      state.isLoading = true;
    },
    getSalesDataSuccess: (state, action) => {
      state.isLoading = false;
      state.totalVentes = action.totalVentes;
      state.totalAchats = action.totalAchats;
      state.totalVentesDirect = action.totalVentesDirect;
      state.totalFactureImpayees = action.totalFactureImpayees;
      state.totalAchatsImpayees = action.totalAchatsImpayees;
      state.lowStockItems = action.lowStockItems;
      state.totalInvoices = action.totalInvoices;
      state.invoicePayed = action.invoicesPayed;
      state.invoiceNotPayed = action.invoicesNotPayed;
      state.purchasePayed = action.purchasePayed;
      state.purchaseNotPayed = action.purchaseNotPayed;
      state.totalPurchases = action.totalPurchases;
      state.totalSalesReturns = action.totalSalesReturns;
      state.totalPurchaseReturns = action.totalPurchaseReturns;
      state.totalPOSSales = action.totalPOSSales;
      state.totalExpenses = action.totalExpenses;

    },
    getSalesDataFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    finishFetching: (state) => {
      state.isLoading = false;
    },
    fetchedData: (state, payload) => {
      state.isLoading = false;
      state.sales = payload.body.content;
      state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
      state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
      state.pageNumber = payload.body.pageNumber;
    },
    getTotalSalesToday: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getTotalSalesThisWeek: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getTotalSalesThisMonth: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getTotalSalesThisYear: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    createSaleSuccess: (state) => {
      state.isLoading = false;
      state.cart = [];
      state.montantTotalTTC = 0;
      state.montantTotalHT = 0;
      state.montantTotalTaxe = 0;
    },
    createSaleFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    search: (state) => {
      state.isLoading = true;
    },
    downloadBill: (state) => {
      state.isFetching = true;
    },
    getSalesReport: (state) => {
      state.isLoading = true;
    },

    fetchError: (state, action) => {
      state.isLoading = false;
      state.error = "An error occurred";
    },

    setCart:(state,action)=>{
      if(action){
        state.cart = action.lignes.map(ligne => ({
          ...ligne,
          quantite: parseFloat(ligne.quantiteLivree)
        }));
        state.montantTotalHT = action.montantTotalHT;
        state.montantTotalTTC = action.montantTotalTTC;
        state.montantTotalTaxe = action.montantTotalTaxe;
      }
    },

    addToCart: (state, action) => {
      const existingItem = state.cart.find(item => item.articleId === action.id);
      if (existingItem) {
        existingItem.quantite += 1;
      } else {
        const newItem = {
          articleId: action.id,
          articleNom: action.categorieLibelle + " - " + action.libelle,
          quantite: 1,
          prixUnitaireTTC: action.prixVenteTTC1,
          prixUnitaireHT: action.prixVenteTTC1 / (1 + (action.tauxTVAVente || 0.2)),
          unite: action.unite,
          tauxTVA: action.tauxTVAVente || 0.2,
          montantHT: action.prixVenteTTC1 / (1 + (action.tauxTVAVente || 0.2)),
          montantTTC: action.prixVenteTTC1
        };
        state.cart.push(newItem);
      }

      // Recalculate total amounts after adding a new item
      let newHtCumul = 0;
      let newTtcCumul = 0;
      let montantTotalTaxe = 0;

      state.cart.forEach(item => {
        const quantity = parseFloat(item.quantite) || 0;
        const unitPrice = parseFloat(item.prixUnitaireHT) || 0;
        const tauxTVA = parseFloat(item.tauxTVA) || 0;

        newHtCumul += quantity * unitPrice;
        newTtcCumul += (quantity * unitPrice) * (1 + tauxTVA);
        montantTotalTaxe += (quantity * unitPrice) * tauxTVA;
      });

      state.montantTotalHT = newHtCumul;
      state.montantTotalTaxe = montantTotalTaxe;
      state.montantTotalTTC = newTtcCumul.toFixed(0);
    },

    setTotalSales: (state, action) => {
      state.totalSales = action.payload;
    },

    removeFromCart: (state, action) => {
      console.log(action)
      state.cart = state.cart.filter(item => item.articleId !== action);
      // Recalculate htCumul and ttcCumul
      let newHtCumul = 0;
      let newTtcCumul = 0;
      state.cart.forEach(item => {
          newHtCumul += (parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0);
          newTtcCumul += ((parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0)) * (1 + (parseFloat(item.tauxTVA) || 0));
      });

      // Calculate montantTotalTaxe
      let montantTotalTaxe = 0;
      state.cart.forEach(item => {
          const itemTva = ((parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0)) * ((parseFloat(item.tauxTVA) || 0));
          montantTotalTaxe += itemTva;
      });

      state.montantTotalHT = newHtCumul;
      state.montantTotalTaxe = montantTotalTaxe;
      state.montantTotalTTC = newTtcCumul.toFixed(0);
    },

    handleInputChange: (state, action) => {
      console.log(action.index)
      const newItems = state.cart;
      const updatedItem = { ...newItems[action.index], [action.name]: action.value };
      
      // Calculate montantHT and montantTTC for the current item
      const quantity = parseFloat(updatedItem.quantite) || 0;
      const unitPriceTTC = parseFloat(updatedItem.prixUnitaireTTC) || 0;
      const tauxTVA = parseFloat(updatedItem.tauxTVA) || 0;
      const unitPriceHT = (unitPriceTTC / (1 + tauxTVA)).toFixed(2);
      const montantHT = (quantity * unitPriceHT).toFixed(2);
      const montantTTC = unitPriceTTC * quantity;

      // Update the montantHT and montantTTC in the newItems array
      updatedItem.montantHT = montantHT;
      updatedItem.montantTTC = montantTTC;
      updatedItem.prixUnitaireHT = unitPriceHT;

      // Update the item in the newItems array
      newItems[action.index] = updatedItem;
      

      // Recalculate htCumul and ttcCumul
      let newHtCumul = 0;
      let newTtcCumul = 0;
      newItems.forEach(item => {
          newHtCumul += (parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0);
          newTtcCumul += ((parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0)) * (1 + (parseFloat(item.tauxTVA) || 0));
      });

      // Calculate montantTotalTaxe
      let montantTotalTaxe = 0;
      newItems.forEach(item => {
          const itemTva = ((parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0)) * ((parseFloat(item.tauxTVA) || 0));
          montantTotalTaxe += itemTva;
      });

      state.cart = newItems;
      state.montantTotalHT = newHtCumul;
      state.montantTotalTaxe = montantTotalTaxe;
      state.montantTotalTTC = newTtcCumul.toFixed(0);
      
    },

    updateSale: (state) => {
      state.isLoading = true;
    },

    generateInvoice: (state) => {
      state.isLoading = true;
    },

    clearCart: (state) => {
      state.cart = [];
      state.montantTotalTTC = 0;
      state.montantTotalHT = 0;
      state.montantTotalTaxe = 0;
    }
  },
  sagas: (A) => ({
    *[A.search]({ payload }) {
      try {
        const { data } = yield call(search, payload);
        yield put(A.finishFetching());
        yield put(A.fetchedData(data));
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },
    *[A.generateInvoice]({ payload }) {
      try {
        const { data } = yield call(generateInvoice, payload.saleId);
        var byteCharacters = atob(data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: "application/pdf;base64" });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        yield put(A.finishFetching());
      } catch (error) {
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },
    *[A.updateSale]({ payload }) {
      try {
        const { data } = yield call(updateSale, payload.sale.id, payload.sale);
        yield put(A.finishFetching());
        yield call(payload.onSuccess);
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },
    *[A.createSale]({ payload }) {
      try {

        const { data } = yield call(createSale, payload.data);
        yield put(A.createSaleSuccess());

        if (payload.onSuccess) {
          yield call(payload.onSuccess, data);
        }
      } catch (error) {
        yield put(A.createSaleFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error.response.data);
        }
      }
    },
    *[A.downloadBill]({ payload }) {
      try {
        console.log(payload);
        const { data } = yield call(downloadBill, payload.id);
        yield put(A.finishFetching());
        yield call(payload.onSuccess, data);
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },
    *[A.getSalesData]({ payload }) {
      try {
        const { data } = yield call(getSalesData, payload.dateRange);
        yield put(A.getSalesDataSuccess(data));
      } catch (error) {
        yield put(A.getSalesDataFailure(error.message));
      }
    },
    *[A.getSalesReport]({ payload }) {
      try {
        const { data } = yield call(getSalesReport, payload.dateRange);
        yield put(A.finishFetching());
        if (payload.onSuccess) {
          yield call(payload.onSuccess, data.body);
        }
      } catch (error) {
        yield put(A.finishFetching());
        yield put(A.getSalesDataFailure(error.message));

      }
    },
    *[A.fetchSales]({ payload }) {
      try {
        const { data } = yield call(getSales, payload.page, payload.size);
        yield put(A.setSales(data.content));
        yield put(A.setPagination({
          currentPage: payload.page,
          totalPages: data.totalPages,
          pageSize: payload.size,
          totalElements: data.totalElements
        }));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesToday]() {
      try {
        const { data } = yield call(getTotalSalesToday);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesThisWeek]() {
      try {
        const { data } = yield call(getTotalSalesThisWeek);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesThisMonth]() {
      try {
        const { data } = yield call(getTotalSalesThisMonth);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesThisYear]() {
      try {
        const { data } = yield call(getTotalSalesThisYear);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalSalesForDateRange]({ payload }) {
      try {
        const { data } = yield call(getTotalSalesForDateRange, payload.startDate, payload.endDate);
        yield put(A.setTotalSales(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    }
  }),

});

export default saleModule;
export const saleActions = saleModule.actions;